import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // ✅ শুধু আমাদের নিজের API তে token পাঠানো হবে।
  // বাইরের সার্ভিস (যেমন auto-translate) এ Authorization
  // header পাঠালে CORS ভেঙে যেতে পারে, তাই সেগুলো বাদ।
  const isOwnApi = req.url.includes(
    'superbangladesh-api-1.onrender.com'
  );

  if (!isOwnApi) {
    return next(req);
  }

  // =========================================================
  // 🔒 SSR FIX: server-side render (Node.js)-এ `localStorage`
  // বলে কিছু নেই — আগে এখানে সরাসরি localStorage.getItem() কল
  // হতো, যেটা SSR-এ ReferenceError থ্রো করে পুরো HTTP request-টাই
  // ভেঙে দিত (synchronously, subscribe() করার সময়ই)। ফলে যেসব
  // page লোড হওয়ার সাথে সাথেই token লাগিয়ে API কল করে (যেমন
  // profile page), সেগুলো SSR-এ অর্ধেক render হয়ে ক্লায়েন্টে
  // পাঠানো হতো — hydration-এর পর সেটা "loading" অবস্থায় আটকে
  // থাকতো যতক্ষণ না কোনো click/reload zone.js-কে নতুন করে change
  // detection চালাতে বাধ্য করছে। isPlatformBrowser দিয়ে গার্ড
  // করে দেওয়া হলো — SSR-এ শুধু token ছাড়াই request পাঠাবে,
  // ক্লায়েন্টে hydrate হওয়ার পর browser-এ আবার সঠিক token দিয়ে
  // রিকোয়েস্ট যাবে।
  // =========================================================
  const platformId = inject(PLATFORM_ID);
  const token = isPlatformBrowser(platformId)
    ? localStorage.getItem('token')
    : null;

  if (token) {

    req = req.clone({

      setHeaders: {

        Authorization: `Bearer ${token}`

      }

    });

  }

  return next(req);

};